if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
          	// Pagination
            paginationType: 'infinite', // Pagination type: default, infinite, load_more
			/* Optional */
			loadProductFirst: false,
			refineByStyle: 'style2',
          	filterTreeMobileStyle: 'style1', // 'style1', style2', 'style2-fullwidth','style3', 'style3-fullwidth',
          	loadPreviousType: 'infinite', // Load previous type: empty (match with pagination type), load_more, infinite
          	// Scrollback
            enableKeepScrollbackPosition: true, // Scroll to the previous position after going back from Product page
          	paginationTypeAdvanced: true,
		},
	};
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
const size_option_name = 'taille';


// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml': '<div x-data="ProductBadgeItem" x-init="mounted" data-product-tags="{{itemTags}}" data-product-id="{{itemId}}" data-product-handle={{itemHandle}} id="{{itemHandle}}" class="grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
								'<div class="grid-product__content">' +
									'{{itemLabel}}' +
                                    '<!-- include "wishlist-button-collection" with "{{itemId}}" -->'+
									'<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
										'<div class="grid-product__image-mask">'+
											'{{itemQuickShopButton}}' +
											'{{itemImages}}'+
											'{{itemSwatchHoverImages}}' +
										'</div>' +
										'<div class="grid-product__meta">' +
                      '<div class="grid-product__swatches" x-data="GridColorSwatches" x-init="mounted" data-product_handle={{itemHandle}}></div>' +
											'<div class="grid-product__title">{{itemTitle}}</div>' +
											'{{itemVendor}}' +
											'<div class="grid-product__price">{{itemPrice}}</div>' +
											'<div class="grid-product__sale" x-data="ProductItemSaleInfo"></div>' +
											'{{itemReviews}}'+
										'</div>' +
									'</a>' +
								'</div>' +
								'{{itemSwatch}}'+
							'</div>',
    'promotionVideoItemHtml': '<div data-video-id="{{itemId}}" class="image-video-item grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
                                  '<a {{itemHref}}"{{urlRedirect}}" class="fulscreen-video-wrapper">' +
                                      '<video class="image-video-item--inner" width="100%" height="auto" type="video/mp4?v=1617899317" src="{{videoUrl}}" loop="" muted="" playsinline="" autoplay="" controlslist="nodownload" disablepictureinpicture=""></video>' +
                                   '</a>'+
                                   '<div class="image-video-item--title">{{promoTitle}}</div>' +
                               '</div>',
  	'promotionImageItemHtml': '<div data-image-id="{{itemId}}" class="image-video-item grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
                                  '<a {{itemHref}}"{{urlRedirect}}" class="fulscreen-video-wrapper">' +
                                    '<img class="image-video-item--inner" src="{{imageUrl}}">' +
                                   '</a>'+
                                   '<div class="image-video-item--title">{{promoTitle}}</div>' +
                               '</div>',

	// Pagination Template
	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
	'previousDisabledHtml': '',
	'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
	'nextDisabledHtml': '',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">...</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="hidden-label">' + '{{sortingLabel}}' + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};


(function() {
    /* This is to inject boost components into this scope, so we can override component's function */
    BoostPFS.inject(this);
    /************************** BUILD PRODUCT LIST **************************/
    if (Utils.isMobile()) boostPFSFilterConfig.general.limit = 23;
    // Build Product Grid Item
    let tile_index = 1; //SV-
    let TILES_COUNT = document.querySelectorAll('[data-collection-tile]').length;
    ProductGridItem.prototype.compileTemplate = function(data, index) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        /*** Prepare data ***/
        var images = data.images_info;
        // Displaying price base on the policy of Shopify, have to multiple by 100
        var soldOut = !data.available; // Check a product is out of stock
        var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        // console.log(data.handle, data, onSale);
        var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;
        if (Utils.isCollectionPage()) {
            // SV-
            switch (index) {
                case 6:
                    itemHtml += `<div data-index="${tile_index}" x-data="CollectionTile"></div>`;
                    tile_index = (tile_index == TILES_COUNT) ? 1 : (tile_index + 1);
                    break;
                case 14:
                    itemHtml += `<div data-index="${tile_index}" x-data="CollectionTile"></div>`;
                    tile_index = (tile_index == TILES_COUNT) ? 1 : (tile_index + 1);
                    break;
                case 22:
                    itemHtml += `<div data-index="${tile_index}" x-data="CollectionTile"></div>`;
                    tile_index = (tile_index == TILES_COUNT) ? 1 : (tile_index + 1);
                    break;
            }
        }
        // Add Promo Template
        // if (boostPFSThemeConfig.custom.active_collections.indexOf(boostPFSConfig.general.collection_handle) == -1) {
        //     if (index == 6) {
        //       itemHtml += imageVideo(data);
        //     }
        //     if (index == 14) {
        //       itemHtml += imageVideo(data);
        //     }
        //    	if (index == 22) {
        //       itemHtml += imageVideo(data);
        //     }
        // }
        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? images[0]['src'] : boostPFSConfig.general.no_image_url;
        if (Globals.queryParams.hasOwnProperty('pf_opt_taille')) {
            var selectedSizes = Globals.queryParams.pf_opt_taille;
            for (var k = 0; k < selectedSizes.length; k++) {
                var selectedSize = selectedSizes[k].toLowerCase();
                var flag = false;
                for (var i = 0; i < data.variants.length; i++) {
                    var variant = data['variants'][i];
                    if (variant.hasOwnProperty('merged_options') && variant['merged_options'].length > 0) {
                        for (var j = 0; j < variant['merged_options'].length; j++) {
                            var mergeValue = variant['merged_options'][j].toLowerCase();
                            if (mergeValue.indexOf(selectedSize) > -1 && variant['image'] !== null) {
                                itemThumbUrl = variant['image'];
                                flag = true;
                                break;
                            }
                        }
                    }
                    if (flag) break;
                }
            }
        }
        // Add Thumbnail
        var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
        var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
        var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
        var bgset = buildBgSet(thumb);
        var itemImagesHtml = '';
        // Add Image Hover State
        let firstIndex = data.ts_custom_fields.images_info.findIndex(e => e['src'] === itemThumbUrl);
        let lastIndex;
        for (let idx = firstIndex + 1; idx < data.ts_custom_fields.images_info.length; idx++) {
            for (let k = 0; k < data.variants.length; k++) {
                if (data.variants[k]['image'] === data.ts_custom_fields.images_info[idx]['src']) {
                    lastIndex = idx - 1;
                    break;
                }
            }
            if (lastIndex) break;
        }
        let hoverImages = lastIndex ? data.ts_custom_fields.images_info[lastIndex]['src'] : data.ts_custom_fields.images_info[data.ts_custom_fields.images_info.length - 1]['src'];;
        // END Image Hover State
        if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
            itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
            // Add Image Hover State
            itemImagesHtml += `<img 
                                    class="product-block--slide lazyload" 
                                    tabindex="-1" 
                                    data-src="${hoverImages}" 
                                    data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                                    data-aspectratio="${aspectRatio}"
                                    data-sizes="auto"
                                    >`;
            // END Image Hover State
            itemImagesHtml += '<img ' +
                'class="grid-product__image pfs-main-image ';
            if (index > 24) {
                itemImagesHtml += 'lazyload';
            }
            itemImagesHtml += '" ';
            if (index <= 24) {
                itemImagesHtml += 'src="' + itemThumbUrl + '"';
            }
            itemImagesHtml += 'data-src="' + itemThumbUrl + '" ' +
                'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                'data-aspectratio="' + aspectRatio + '" ' +
                'data-sizes="auto" ' +
                'alt="{{itemTitle}}">';
            itemImagesHtml += '</div>';
        } else {
            itemImagesHtml += '<div ' +
                'class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + ' lazyload"' +
                'data-bgset="' + bgset + '"' +
                'data-sizes="auto">';
            itemImagesHtml += '</div>';
        }
        if (!soldOut) {
            if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
                bgset = buildBgSet(images[1]);
                itemImagesHtml += '<div ' +
                    'class="grid-product__secondary-image small--hide lazyload"' +
                    'data-bgset="' + bgset + '"' +
                    'data-sizes="auto">' +
                    '</div>';
            }
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
        // Add Price
        /**
         * Case 2: New Merge Tool which is placed in the Settings app
         * Add the code below to the buildProductGridItem function or buildProductListItem function  
         */
        var itemPrice = data.price_min;
        var itemPriceOriginal = data.compare_at_price_min;
        var itemPriceHtml = !Globals.queryParams.hasOwnProperty('pf_opt_taille') ? boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, '') : '';

        if (Globals.queryParams.hasOwnProperty('pf_opt_taille')) {
            var selectedSizes = Globals.queryParams.pf_opt_taille;
            for (var k = 0; k < selectedSizes.length; k++) {
                var selectedSize = selectedSizes[k].toLowerCase();
                var flagPrice = false;
                for (var i = 0; i < data.variants.length; i++) {
                    var variant = data['variants'][i];
                    if (variant.hasOwnProperty('merged_options') && variant['merged_options'].length > 0) {
                        for (var j = 0; j < variant['merged_options'].length; j++) {
                            var mergeValue = variant['merged_options'][j].toLowerCase();
                            if (mergeValue.indexOf(selectedSize) > -1 && variant['price'] !== null) {
                                itemPrice = variant['price'];
                                itemPriceOriginal = variant['compare_at_price'];
                                var itemPriceSale = variant['compare_at_price'];
                                flagPrice = true;
                                break;
                            }
                        }
                    }
                    if (flagPrice) break;
                }
            }
            if (onSale) {
                itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
                if (Globals.queryParams.hasOwnProperty('pf_opt_taille')) {
                    itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(itemPriceOriginal) + '</span>';
                } else {
                    itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
                }
                itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
            }
        } else {
            if (onSale) {
                var price_min_with_ja = data.price;
                var flag_set_price_min = true;
                data.variants.forEach(function(variant) {
                    if (variant.option_matte == "Ja" && variant.merged_options.indexOf(`${size_option_name}:Muster`) === -1) {
                        flag_set_price_min = false;
                        var compare_price_ja = variant.compare_at_price;
                    }
                    var comparePrice = data.variants[0].compare_at_price;
                    itemPriceHtml += '<span class="boost-first-sale grid-product__price--original">' + Utils.formatMoney(comparePrice) + '</span>';
                    itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
                });
            }
        }
        if (priceVaries) {
            if (flagPrice) {
                itemPriceHtml += '<span class="grid-product__price--main '+ (onSale ? 'is-sale-price' : '') +'">' + Utils.formatMoney(itemPrice) + '</span>';
            } else {
                // get min price with merge option = "Ja"
                var price_min_with_ja = data.price_max;
                var flag_set_price_min = true;
                data.variants.forEach(function(variant) {
                    if (variant.option_matte == "Ja" && variant.merged_options.indexOf(`${size_option_name}:Muster`) === -1) {
                        flag_set_price_min = false;
                        if (variant.price < price_min_with_ja) {
                            price_min_with_ja = variant.price;
                        }
                    }
                });
                if (flag_set_price_min) {
                    price_min_with_ja = data.price_min;
                }
                // SV-
                let standard_pad_variants = data.variants.filter(variant => variant.options.indexOf(window.theme.settings.standard_matte_backend) !== -1)
                if (standard_pad_variants.length) {
                    let least_price_variant = standard_pad_variants.reduce((variantMin, variant) => variant.price < variantMin.price ? variant : variantMin);
                    // console.log(least_price_variant)
                    price_min_with_ja = least_price_variant.price;
                }
                itemPriceHtml += '<span class="grid-product__price--main '+ (onSale ? 'is-sale-price' : '') +'">' + Utils.formatMoney(price_min_with_ja) + '</span>';
            }
        } else {
            itemPriceHtml += Utils.formatMoney(itemPrice);
        }
        if (onSale && boostPFSConfig.custom.product_save_amount) {
            var savePrice = '';
            if (boostPFSConfig.custom.product_save_type == 'dollar') {
                savePrice = Utils.formatMoney(data.compare_at_price_min - itemPrice);
            } else {
                savePrice = Math.round((data.compare_at_price_min - itemPrice) * 100 / data.compare_at_price_min);
                savePrice += '%';
            }
            var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
            itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
        }

        // SV- Apply automatic discount based on product tags
        if (theme.settings.enable_pdp_discount) {            
            let standard_pad_variants = data.variants.filter(variant => variant.options.indexOf(window.theme.settings.standard_matte_backend) !== -1)
            if (!Globals.queryParams.hasOwnProperty('pf_opt_taille') && standard_pad_variants.length) {
                let least_price_variant = standard_pad_variants.reduce((variantMin, variant) => variant.price < variantMin.price ? variant : variantMin);
                // console.log(least_price_variant)
                itemPrice = least_price_variant.price;
            }

            [1,2,3].forEach((i) => {
              let discount_id = `pdp_discount_${i}`;
              let tag = theme.settings[discount_id][0];
              let percent = theme.settings[discount_id][1];
              if (data.tags.includes(tag)) {
                let price_off = itemPrice * (percent / 100);
                itemPriceOriginal = itemPrice;
                itemPrice = itemPrice - price_off;

                itemPriceHtml = !Globals.queryParams.hasOwnProperty('pf_opt_taille') ? boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, '') : '';
                itemPriceHtml += '<span class="boost-first-sale grid-product__price--original">'+ Utils.formatMoney(itemPriceOriginal) +'</span>';
                itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
                itemPriceHtml += '<span class="grid-product__price--main is-sale-price">' + Utils.formatMoney(itemPrice) + '</span>';
              }
            });
        }

        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
        // Add soldOut class
        var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
        itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
        // Add label
        var customLabel = '';
        data.tags.forEach(function(tag) {
            if (tag.startsWith('_label_')) {
                if (!customLabel) {
                    customLabel = tag.replace('_label_', '');
                }
            }
        });
        var itemLabelHtml = '';
        if (customLabel) {
            itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
        } else {
            // soldOut Label
            if (soldOut) {
                itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
            } else if (onSale) {
                itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
            }
        }
        itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);
        // Add Vendor
        var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
        // Add Quick shop
        var itemQuickShopClass = '';
        var itemQuickShopButtonHtml = '';
        if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
            itemQuickShopClass = 'grid-product__has-quick-shop';
            itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
                '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
                '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
        itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);
        // Add Reviews
        if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
            var reviewHtml = '';
            if (boostPFSConfig.custom.enable_product_reviews) {
                reviewHtml = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>';
            }
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
        }
        // Color swatch
        var swatchHtml = buildSwatch(data, this);
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
        itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);
        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemTags}}/g, data.tags.join('~'));
        //itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        var itemUrlHtml = Utils.buildProductItemUrl(data);
        if (Globals.queryParams.hasOwnProperty('pf_opt_taille') && Globals.queryParams.pf_opt_taille.length == 1) {
            var selectedSize = Globals.queryParams.pf_opt_taille[0];
            var options = data.options_with_values.filter(function(e) {
                // SV- option position 1 is size option
                return e.position == 1;
                // return (e.name).toLowerCase() == 'gre';
            });
            if (typeof options[0] !== 'undefined') {
                // Set Url with variant
                var matchVariant = data.variants.filter(function(e) {
                    for (var i = 0; i < e.merged_options.length; i++) {
                        if (e.merged_options[i].toLowerCase().indexOf(selectedSize.toLowerCase()) !== -1) {
                            return true;
                        }
                    }
                });
                if (typeof matchVariant[0] !== 'undefined' && typeof matchVariant[0]['id'] !== 'undefined' && matchVariant[0]['id'] !== null) {
                    itemUrlHtml = itemUrlHtml + '?variant=' + matchVariant[0]['id'];
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrlHtml);
        return itemHtml;
    };
    // Promote Element
    var currentIndex = 0;
    var nextIndex = 0;
    var howManyLoops = 0;
    var indexForLoop = 1;
    var loopCount = 1;

    function imageVideo(data) {
        var html = '';
        var imageVideoArr = boostPFSThemeConfig.custom.active_video_image.split(',');
        currentIndex = imageVideoArr.findIndex(function(element) {
            if (element.indexOf(boostPFSConfig.general.collection_handle) !== -1 && element.indexOf('collection:') !== -1) {
                return element;
            }
        });
        for (var uu = currentIndex + 1; uu < imageVideoArr.length; uu++) {
            var elm = imageVideoArr[uu];
            if (elm.indexOf('collection:') !== -1) {
                nextIndex = uu;
                break;
            }
        }
        if (nextIndex !== 0) {
            howManyLoops = (nextIndex - (currentIndex + 1)) / 3;
            for (var k = currentIndex; k < (nextIndex - 1); k++) {
                if (typeof imageVideoArr[k] !== 'undefined' && imageVideoArr[k].indexOf(boostPFSConfig.general.collection_handle) !== -1 && imageVideoArr[k].indexOf('collection:') !== -1) {
                    if (imageVideoArr[k + indexForLoop].indexOf('image:') !== -1) {
                        var itemImage = imageVideoArr[indexForLoop].replace(/<p>/g, '');
                        itemImage = itemImage.replace(/<\/p>/g, '').split('image:');
                        var itemImageTitle = imageVideoArr[k + indexForLoop + 1].replace(/<p>/g, '');
                        itemImageTitle = itemImageTitle.replace(/<\/p>/g, '').split('itle:');
                        var urlImage = imageVideoArr[k + indexForLoop + 2].replace(/<p>/g, '');
                        urlImage = urlImage.replace(/<\/p>/g, '').split('ink:');
                        html = boostPFSTemplate.promotionImageItemHtml;
                        html = html.replace(/{{imageUrl}}/g, itemImage[1]);
                        html = html.replace(/{{promoTitle}}/g, itemImageTitle[1]);
                        html = html.replace(/{{urlRedirect}}/g, urlImage[1]);
                        var href = '';
                        if (urlImage[1].length > 5) {
                            href = 'href='
                        };
                        html = html.replace(/{{itemHref}}/g, href);
                        loopCount = loopCount + 1;
                        indexForLoop = indexForLoop + 3;
                        if (loopCount > howManyLoops) {
                            indexForLoop = 1;
                            loopCount = 1;
                        }
                        break;
                    }
                    if (imageVideoArr[k + indexForLoop].indexOf('video:') !== -1) {
                        var imageVideo = imageVideoArr[indexForLoop].replace(/<p>/, '');
                        imageVideo = imageVideo.replace(/<\/p>/g, '').split('deo:');
                        var itemVideoTitle = imageVideoArr[k + indexForLoop + 1].replace(/<p>/g, '');
                        itemVideoTitle = itemVideoTitle.replace(/<\/p>/g, '').split('itle:');
                        var urlVideo = imageVideoArr[k + indexForLoop + 2].replace(/<p>/g, '');
                        urlVideo = urlVideo.replace(/<\/p>/g, '').split('ink:');
                        html = boostPFSTemplate.promotionVideoItemHtml;
                        html = html.replace(/{{videoUrl}}/g, imageVideo[1]);
                        html = html.replace(/{{promoTitle}}/g, itemVideoTitle[1]);
                        html = html.replace(/{{urlRedirect}}/g, urlVideo[1]);
                        var href = '';
                        if (urlVideo[1].length > 5) {
                            href = 'href='
                        };
                        html = html.replace(/{{itemHref}}/g, href);
                        loopCount = loopCount + 1;
                        indexForLoop = indexForLoop + 3;
                        if (loopCount > howManyLoops) {
                            indexForLoop = 1;
                            loopCount = 1;
                        }
                        break;
                    }
                }
            }
        } else {
            howManyLoops = (imageVideoArr.length + 1) / 3;
            for (var k = currentIndex; k < imageVideoArr.length; k++) {
                if (typeof imageVideoArr[k] !== 'undefined' && imageVideoArr[k].indexOf(boostPFSConfig.general.collection_handle) !== -1 && imageVideoArr[k].indexOf('collection:') !== -1) {
                    if (imageVideoArr[k + indexForLoop].indexOf('image:') !== -1) {
                        var itemImage = imageVideoArr[indexForLoop].replace(/<p>/g, '');
                        itemImage = itemImage.replace(/<\/p>/, '').split('age:');
                        var itemImageTitle = imageVideoArr[k + indexForLoop + 1].replace(/<p>/g, '');
                        itemImageTitle = itemImageTitle.replace(/<\/p>/g, '').split('itle:');
                        var urlImage = imageVideoArr[k + indexForLoop + 2].replace(/<p>/g, '');
                        urlImage = urlImage.replace(/<\/p>/g, '').split('ink:');
                        html = boostPFSTemplate.promotionImageItemHtml;
                        html = html.replace(/{{imageUrl}}/g, itemImage[1]);
                        html = html.replace(/{{promoTitle}}/g, itemImageTitle[1]);
                        html = html.replace(/{{urlRedirect}}/g, urlImage[1]);
                        var href = '';
                        if (urlImage[1].length > 5) {
                            href = 'href='
                        };
                        html = html.replace(/{{itemHref}}/g, href);
                        loopCount = loopCount + 1;
                        indexForLoop = indexForLoop + 3;
                        if (loopCount > howManyLoops) {
                            indexForLoop = 1;
                            loopCount = 1;
                        }
                        break;
                    }
                    if (imageVideoArr[k + indexForLoop].indexOf('video:') !== -1) {
                        var imageVideo = imageVideoArr[indexForLoop].replace(/<p>/g, '');
                        imageVideo = imageVideo.replace(/<\/p>/g, '').split('deo:');
                        var itemVideoTitle = imageVideoArr[k + indexForLoop + 1].replace(/<p>/g, '');
                        itemVideoTitle = itemVideoTitle.replace(/<\/p>/g, '').split('itle:');
                        var urlVideo = imageVideoArr[k + indexForLoop + 2].replace(/<p>/g, '');
                        urlVideo = urlVideo.replace(/<\/p>/g, '').split('ink:');
                        html = boostPFSTemplate.promotionVideoItemHtml;
                        html = html.replace(/{{videoUrl}}/g, imageVideo[1]);
                        html = html.replace(/{{promoTitle}}/g, itemVideoTitle[1]);
                        html = html.replace(/{{urlRedirect}}/g, urlVideo[1]);
                        var href = '';
                        if (urlVideo[1].length > 5) {
                            href = 'href='
                        };
                        html = html.replace(/{{itemHref}}/g, href);
                        loopCount = loopCount + 1;
                        indexForLoop = indexForLoop + 3;
                        if (loopCount > howManyLoops) {
                            indexForLoop = 1;
                            loopCount = 1;
                        }
                        break;
                    }
                }
            }
        }
        return html;
    }
    // Build Swatch
    function buildSwatch(data, _this) {
        var itemSwatchHtml = '';
        var itemSwatchHoverImagesHtml = '';
        if (boostPFSConfig.custom.collection_color_swatches) {
            var swatchItems = [];
            var swatchHoverImages = [];
            data.options_with_values.forEach(function(option, index) {
                var option_name = option.name.toLowerCase();
                if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
                    var option_index = index;
                    var values = [];
                    data.variants.forEach(function(variant) {
                        var value = variant.merged_options[option_index].split(':')[1];
                        if (values.indexOf(value) == -1) {
                            values.push(value);
                            var colorValueSlugify = Utils.slugify(value);
                            var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
                            var variantImage = Utils.optimizeImage(variant.image, '400x');
                            var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                                'data-variant-id="{{variantId}}" ' +
                                'data-variant-image="{{variantImage}}" ' +
                                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                                '</a>';
                            swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
                            swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
                            swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
                            swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
                            swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
                            swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());
                            var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';
                            swatchItems.push(swatchItem);
                            swatchHoverImages.push(swatchHoverImage);
                        }
                    });
                }
            });
            if (swatchItems.length > 1) {
                itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
                itemSwatchHoverImagesHtml = swatchHoverImages.join('');
            }
        }
        return {
            itemSwatch: itemSwatchHtml,
            itemSwatchHoverImages: itemSwatchHoverImagesHtml
        };
    }

    function buildBgSet(image) {
        var html = '';
        if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
            var aspectRatio = image.width / image.height;
            if (image.width <= 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
            if (image.width > 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
            if (image.width > 360) html += Utils.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
            if (image.width > 540) html += Utils.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
            if (image.width > 720) html += Utils.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
            if (image.width > 900) html += Utils.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
            if (image.width > 1080) html += Utils.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
            if (image.width > 1296) html += Utils.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
            if (image.width > 1512) html += Utils.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
            if (image.width > 1728) html += Utils.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
        }
        return html;
    }
    /************************** END BUILD PRODUCT LIST **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        var paginationHtml = '';
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }
        return '';
    };
    /************************** BUILD TOOLBAR **************************/
    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        var html = '';
        var sortingArr = Utils.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{sortingLabel}}/g, Labels.sorting);
        }
        return html;
    };
    /* buildExtraProductList */
    ProductList.prototype.afterRender = function(data) {
        if (!data) {
            data = this.data;
        }
        this.buildExtrasProductListByAjax(data, 'boost-integration', function(results) {
            results.forEach(function(result) {
                // Append the custom html to product item
                jQ('[data-product-id="' + result.id + '"] .grid-product__meta').append(result.unit_price);
            })
        })
        // jQ('.boost-first-sale').each(function() {
        //     var text = jQ(this).text();
        //     text = text.replace('00', ',00')
        //     var newtext = '€' + text;
        //     jQ(this).text(newtext)
        // })
        imageVideoHeight();

      // SV- boost fix for scroll position when filter applied
      window.addEventListener("pageshow", function(evt){
  		if(evt.persisted && Utils.isiOS()){
          location.reload();
        }
      }, false);

      // set a cart attribute to capture selected size
      (async() => {
        let size_filter_id = GetSizeFilterId();
        if (Globals.queryParams.hasOwnProperty(size_filter_id)) {
          let cart = await GetCartJS();
          let attribute_selected_size = cart.attributes[size_filter_id];
          let selected_size = [...Globals.queryParams[size_filter_id]].splice(-1)[0];
          if (selected_size !== attribute_selected_size) {
            let update_attr = {
              'pf_opt_gre': null
            };
            update_attr['size_filter_id'] = size_filter_id;
            update_attr[size_filter_id] = selected_size;
            console.log('updating cart size attribute', update_attr);
            await UpdateCartAttribute(update_attr);
            // signal product linked swatches to load - after update
            document.dispatchEvent(new CustomEvent('load-product-linked-swatches', {detail: {size: selected_size}}));
          }
          else {
            // signal product linked swatches to load - initial
            document.dispatchEvent(new CustomEvent('load-product-linked-swatches', {detail: {size: selected_size}}));
          }
        }
        else {
          let update_attr = {
            'pf_opt_gre': null
          };
          update_attr[size_filter_id] = null;
          console.log('updating cart size attribute', update_attr);
          await UpdateCartAttribute(update_attr);
          // signal product linked swatches to load
          document.dispatchEvent(new CustomEvent('load-product-linked-swatches', {detail: {size: null}}));
        }
      })();
	};

	/* buildAdditionalElements */
	Filter.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;
        // Build total products text
        var totalProductText = '';
        if (data.total_product == 1) {
            totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
            totalProductText = totalProductText.replace('Produkte', 'Design');
        } else {
            totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
            totalProductText = totalProductText.replace('Produkte', 'Designs')
        }
        jQ('.boost-pfs-filter-total-product').html(totalProductText);
        // Build filter button text on mobile
        var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
        if (numSelectedFilter) {
            jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
            jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
        } else {
            jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
            jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
        }
        // Call theme init function
        //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
        jQ(document).ready(function() {
            if (typeof theme !== null && window.theme) {
                // theme.collectionTemplate.reinit();
                AOS.refreshHard();
                // // Setup page transition classes
                // if (typeof theme.pageTransitions == 'function') theme.pageTransitions();
                // // Reload quick shop buttons
                // theme.initQuickShop(true);
                // // Reload products inside each quick shop
                // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
                if (window.$ && typeof $ == 'function') {
                    $(window).off('popstate');
                }
            }
            // Build quick view modals
            var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
            if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
                jQ('.boost-pfs-quick-shop-modal-container').html('');
                if (data.products.length > 0) {
                    data.products.forEach(function(product) {
                        var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
                        jQ.ajax({
                            url: quickUrl,
                            success: function(result) {
                                numberQuickViewModalLoaded++;
                                jQ('.boost-pfs-quick-shop-modal-container').append(result);
                                if (numberQuickViewModalLoaded == data.products.length) {
                                    // theme.collectionTemplate.reinit();
                                    // AOS.refreshHard();
                                    // // Setup page transition classes
                                    // if (typeof theme.pageTransitions == 'function') theme.pageTransitions();
                                    // Reload quick shop buttons
                                    theme.initQuickShop(true);
                                    theme.collapsibles.init();
                                    // Reload products inside each quick shop
                                    //if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
                                    numberQuickViewModalLoaded = 0;
                                    jQ('.quick-product__btn').removeClass('bc-hide');
                                }
                            }
                        });
                    });
                }
            }
            if (isFirstLoad) {
                isFirstLoad = false;
            }
            jQ('.js-drawer-open-collection-filters').on('click', function() {
                jQ('.' + Class.filterOption).each(function() {
                    var showMoreType = jQ(this).data('show-more-type');
                    if (showMoreType && jQ(this).data('display-type') != 'range') {
                        self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
                    }
                });
            });
        });
        // Filter Options
        jQ('.boost-pfs-filter-load-more-loading').html(`<div class="boost-pfs-custom-loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`);
        filterButtons(data.filter);
        activeFilterButton();
        optionOnClick();
        imageVideoHeight();
        if (data.filter) {
            setConfig('filterOptions', data.filter.options);
        };
        // Scroll to Top After Filter pr Clear All Filter
        // scrollToTopFilter(eventType); //SV-
        // Build Image Hover State Event on Mobile
        jQ('.grid-product__image-mask .image-wrap').on({
            'touchstart': function(e) {
                /* do something... grid-product__image pfs-main-image*/
                jQ('.boost-pfs-filter-products').find('.grid-product__image-mask .image-wrap .grid-product__image.pfs-main-image.opacity--hover').removeClass('opacity--hover');
                jQ(this).find('.grid-product__image.pfs-main-image').addClass('opacity--hover');
            },
            'touchmove': function(e) {
                /* do something... grid-product__image pfs-main-image*/
                jQ('.boost-pfs-filter-products').find('.grid-product__image-mask .image-wrap .grid-product__image.pfs-main-image.opacity--hover').removeClass('opacity--hover');
                jQ(this).find('.grid-product__image.pfs-main-image').addClass('opacity--hover');
            }
        });
        jQ(document).on({
            'touchstart': function(e) {
                /* do something... */
                if (!jQ(e.target).hasClass('grid-product__image') && !jQ(e.target).hasClass('pfs-main-image')) {
                    jQ('.boost-pfs-filter-products').find('.grid-product__image-mask .image-wrap .grid-product__image.pfs-main-image.opacity--hover').removeClass('opacity--hover');
                }
            }
        });
        // END Build Image Hover State Event on Mobile

        // Boost-215469619487636 -- Scroll to top
        if (eventType == 'filter') {
            window.scrollTo({
                top: jQ('.boost-pfs-filter-products').offset().top - 200,
                left: 0
                // behavior: 'smooth'
            });
        }
    };
    theme.preloadProductModal = function(handle, $btn) {
        var $holder = $('#QuickShopHolder-' + handle);
        var url = theme.routes.home + 'products/' + handle + '?view=modal';
        $holder.load(url + ' .product-section[data-product-handle=' + handle + ']', function() {
            sections.register('product-template', theme.Product, $holder);
            $btn.removeClass('quick-product__btn--not-ready');
            AOS.refreshHard();
        });
    }
    /* If the quickview does not work, please try the solution below
    	1. Add the class "grid-product" to the product item

    	2. Change the theme code in FilterResults.prototype after render to only have this code:              theme.sections.reinit()              theme.initGlobals();              theme.initQuickShop();              theme.rteInit();

    	3. Remove the code theme.preloadProductModal
     */
    // Scroll to Top After Filter pr Clear All Filter
    var scrollEvent = true;

    function scrollToTopFilter(eventType) {
        if ((eventType == 'filter' || eventType == 'clearAll' || eventType == 'clear') && scrollEvent && Globals.queryParams.event_type !== 'page') {
            scrollEvent = false;
            window.scrollTo({
                top: 1220,
                behavior: 'smooth'
            });
            setTimeout(function() {
                scrollEvent = true;
            }, 5000)
        }
    }
    /* Expand Filter */
    function activeFilterButton() {
        jQ('.pfs-collection-grid-filter-btn').on('click', function() {
            setTimeout(function() {
                jQ('body').toggleClass('boost-pfs-filter-tree-open-body');
            }, 500);
        });
        jQ('.Drawer__Close.Icon-Wrapper--clickable, .Drawer__Footer .Button--primary').click(function() {
            jQ('body').removeClass('boost-pfs-filter-tree-open-body');
        });
        jQ('.PageOverlay').click(function() {
            jQ('body').removeClass('boost-pfs-filter-tree-open-body');
        });
        // Bind changing options with enter/space key for ADA
        jQ('.boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay').on('keydown', (event) => {
            if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
                jQ(event.target).click();
            }
        });
        // Fix issue header fix on the Parallax theme
        if (jQ('.mm-fixed-top').length > 0) {
            var headerFixedHeight = jQ('.mm-fixed-top').height();
            jQ('.boost-pfs-filter-collection-header-wrapper').css('margin-top', headerFixedHeight);
        }
    }
    // Filter Buttons 
    const OPTION_STORAGE_KEY = {};
    var config = JSON.parse(localStorage.getItem(OPTION_STORAGE_KEY)) || {};

    function setConfig(key, value) {
        config[key] = value;
        localStorage.setItem(OPTION_STORAGE_KEY, JSON.stringify(config));
    };

    function filterButtons(filter) {
        // Option Buttons
        var buttonHtml = '';
        var mainCount = 0;
        if (filter) {
            var options = filter.options;
        } else {
            var options = config.filterOptions;
        }
        var optionsAcitve = [];
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            option.isCollapsePC = true;
            if (option.status !== 'disabled' && option.status == 'active' && option.filterOptionId !== "pf_t_swatch_storage") {
                var id = option.filterOptionId;
                optionsAcitve.push(id);
                buttonHtml += '<button ' +
                    'type="button"' +
                    ' data-filter-id="' + '.boost-pfs-filter-option-' + option.label.toLowerCase().replace('ö', 'o') + '"' +
                    ' data-filter-id-config="' + option.filterOptionId + '"' +
                    'class="pfs-collection-grid-filter-btn filter--button btn btn--tertiary additional-button"' +
                    'aria-controls="FilterDrawer">' +
                    '<span class="boost-pfs-title-button">' + option.label + '</span>';
                if (typeof Globals.queryParams[id] !== 'undefined') {
                    buttonHtml += '<span class="boost-pfs-count-button">' + Globals.queryParams[id].length + '</span>';
                    mainCount = mainCount + Globals.queryParams[id].length;
                }
                buttonHtml += '</button>';
            }
        }
        // Main Button
        var mainCount = 0;
        for (var m = 0; m < optionsAcitve.length; m++) {
            if (typeof Globals.queryParams[optionsAcitve[m]] !== 'undefined') {
                mainCount = mainCount + Globals.queryParams[optionsAcitve[m]].length;
            };
        };
        var mainHtml = '<button ' +
            'type="button"' +
            'class="pfs-collection-grid-filter-btn boost-pfs-main-button filter--button btn btn--tertiary"' +
            'aria-controls="FilterDrawer">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M18.005 9.6c0-.3-.3-.5-.5-.5h-8.1c-.2-1-1.2-1.8-2.3-1.8-1.1 0-2.1.8-2.4 1.8h-4.1c-.2 0-.4.1-.5.3-.1.2-.1.4 0 .5.1.2.3.3.5.3h4c.2 1 1.2 1.8 2.4 1.8 1.1 0 2.1-.8 2.3-1.8h8.1c.2 0 .3-.1.4-.2s.2-.2.2-.4zm0-7.3c0-.3-.3-.5-.6-.5h-4.1c-.2-1-1.1-1.8-2.3-1.8-1.1 0-2.1.8-2.4 1.8h-8.1c-.2 0-.4.1-.5.3-.1.2-.1.4 0 .5.1.2.3.3.5.3h8.2c.2 1 1.2 1.8 2.4 1.8 1.1 0 2.1-.8 2.3-1.8h4c.2 0 .3-.1.4-.2.2-.1.2-.3.2-.4zm-5.6 0c0 .7-.6 1.3-1.3 1.3s-1.4-.5-1.4-1.3.6-1.3 1.3-1.3 1.4.6 1.4 1.3zm-4.1 7.4c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.5 1.3 1.3z" fill="#fff"/></svg>' +
            '<span class="boost-pfs-title-button">Alle Filter</span>';
        if (mainCount !== 0) {
            jQ('.Drawer__Footer.Drawer__Footer--padded').addClass('active');
            mainHtml += '<span class="boost-pfs-count-button pfs-count-none">' + mainCount + '</span>';
        } else {
            jQ('.Drawer__Footer.Drawer__Footer--padded').removeClass('active');
        }
        mainHtml += '</button>';
        // render HTMl
        if (jQ('.boost-pfs-filter-buttons').length !== 0) {
            jQ('.boost-pfs-filter-buttons').html(buttonHtml);
        }
        if (jQ('.boost-pfs-main-filter-button').length !== 0) {
            jQ('.boost-pfs-main-filter-button').html(mainHtml)
        }
    };

    function optionOnClick() {
        jQ('.pfs-collection-grid-filter-btn.additional-button').on('click', function() {
            var optionId = jQ(this).attr('data-filter-id').replace(' ', '-');
            //Scroll
            var $options = document.querySelector('#collection-filter-drawer .Drawer__Main');
            $options.querySelector(optionId).scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start",
            });
            // Collapse - Uncollapse
            var targets = jQ('#collection-filter-drawer .Drawer__Main').find('.boost-pfs-filter-option');
            var activeOption = jQ('#collection-filter-drawer .Drawer__Main').find(optionId);
            for (var i = 0; i < targets.length; i++) {
                if (!jQ(targets[i]).hasClass('boost-pfs-filter-option-collapsed')) {
                    jQ(targets[i]).find('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').trigger('click');
                }
            }
            if (jQ(activeOption).hasClass('boost-pfs-filter-option-collapsed')) {
                jQ(activeOption).find('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').trigger('click');
            }
        });
        jQ('.pfs-collection-grid-filter-btn.boost-pfs-main-button').on('click', function() {
            var targetsMain = jQ('#collection-filter-drawer .Drawer__Main').find('.boost-pfs-filter-option');
            for (var j = 0; j < targetsMain.length; j++) {
                if (jQ(targetsMain[j]).hasClass('boost-pfs-filter-option-collapsed')) {
                    jQ(targetsMain[j]).find('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').trigger('click');
                }
            }
        });
    }
    // Filter tree Mockup
    FilterOptionItemList.prototype.getTemplate = function() {
        var filterOptionIds = ["pf_t_stil","pf_opt_taille","pf_t_farbe","pf_t_textur","pf_t_produkt"]
        var filterOptionId = this.parent.filterOptionId;
        var swatchSettings = Settings.getSettingValue('swatch_settings');
        var swatchUrl = '';
        // Find case-insensitive swatch key
        if (swatchSettings) {
            var swatchKeys = Object.keys(swatchSettings);
            if (Array.isArray(swatchKeys) && swatchKeys.length > 0) {
                var swatchKey = swatchKeys.find(key =>
                    key.replace('pfs-swatch-', '') == this.value ||
                    key.replace('pfs-swatch-', '').toLowerCase() == this.value.toLowerCase());
                if (swatchSettings[swatchKey]) {
                    swatchUrl = swatchSettings[swatchKey];
                }
            }
        }
        switch (filterOptionId) {
            case "pf_t_stil":
                var width = 30;
                break;
            case "pf_opt_taille":
                var width = 65;
                break;
            case "pf_t_farbe":
                var width = 60;
                break;
            case "pf_t_textur":
                var width = 35;
                break;
            default:
                var width = 35;
        }
        if (this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
            return `
                  <li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
                      <a class="{{class.button}}" href="{{href}}">
                          <span class="boost-pfs-check-box"></span>
                          <span class="boost-pfs-filter-option-value">{{label}}</span>
                          <span class="boost-pfs-filter-option-amount">{{countLabel}}</span>
                      </a>
                  </li>
              `.trim();
            // Else uses <button>
        } else if (filterOptionIds.includes(filterOptionId)) {
            return `
                  <li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
                      <button role="checkbox" class="{{class.button}}">
                          <img class="boost-pfs-filter-option-image" src="` + swatchUrl.imageUrl + `" alt="{{label}}" width="` + width + `">
                          <span class="boost-pfs-filter-option-value">{{label}}</span>
                          <span class="boost-pfs-filter-option-amount">{{countLabel}}</span>
                          <span class="boost-pfs-check-box"></span>
                      </button>
                  </li>
              `.trim();
        } else {
            return `
                  <li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
                      <button role="checkbox" class="{{class.button}}">
                          <span class="boost-pfs-filter-option-value">{{label}}</span>
                          <span class="boost-pfs-filter-option-amount">{{countLabel}}</span>
                          <span class="boost-pfs-check-box"></span>
                      </button>
                  </li>
              `.trim();
        }
    }
    jQ(window).on('resize', function() {
        imageVideoHeight();
    });

    function imageVideoHeight() {
        if (jQ('.fulscreen-video-wrapper').length > 0) {
            var height = jQ('.image-video-item').width();
            jQ('.image-video-item').css('height', height * 3 / 2);
        }
    }
    FilterRefineByItem.prototype.buildLabel = function() {
        var formatLabel = this.filterItemId;
        if (this.filterOption) {
            switch (this.filterOption.displayType) {
                case FilterOptionEnum.DisplayType.RANGE:
                    formatLabel = this.buildLabelRange();
                    break;
                case FilterOptionEnum.DisplayType.RATING:
                    formatLabel = this.buildLabelRating();
                    break;
                case FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS:
                case FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG:
                    formatLabel = this.buildLabelMultiLevel();
                    break;
                default:
                    if (this.filterItem) {
                        formatLabel = Utils.stripHtml(this.filterItem.value);
                    } else {
                        // Fix issue when user filter by a value but the value doesn't exist in filter tree
                        var dummyFilterItem = new FilterOptionItem(this.filterOption.filterTreeType);
                        dummyFilterItem.filterOption = this.filterOption;
                        dummyFilterItem.label = Utils.stripHtml(this.filterItemId);
                        formatLabel = Utils.stripHtml(dummyFilterItem.buildLabel());
                    }
                    break;
            }
        }
        return Utils.stripHtml(formatLabel);
    }

    FilterResult.prototype._changeProductListGobackPreviousPositionStatus = function(handling = false) {
		this.productListGobackPreviousPosition = handling;
	}
    ProductList.prototype._scrollBackToItem = function(scrollData) {
        console.log('123');
        // Scroll back to item
        if (scrollData && scrollData.page && scrollData.productId && scrollData.position && scrollData.url) {
            // Check if the current url is the same with scroll data url
            var cloneQueryParams = JSON.parse(JSON.stringify(Globals.queryParams));
            var scrollUrlQueryString = typeof scrollData.url == 'string' && scrollData.url.split('?').length == 2 ? scrollData.url.split('?')[1] : '';
            const urlParams = new URLSearchParams(scrollUrlQueryString);
            var page = urlParams.get('page');
            if (page) {
                cloneQueryParams.page = page;
            }
            var url = Navigation.buildAddressBarUrl(cloneQueryParams);
            var paginationType = Settings.getSettingValue('general.paginationType');
            var $selectedProduct = this.$element.find('[data-id="' + scrollData.productId + '"]').first();
            var self = this;
            if (!$selectedProduct.length || url != scrollData.url) {
                self.parent._changeProductListGobackPreviousPositionStatus(false);
                return;
            }
            // Default pagination or first page: scroll to position
            if (paginationType == ProductPagination.Type.DEFAULT) {
                window.scrollTo({
                    top: scrollData.position,
                    // behavior: 'smooth'
                    left: 0
                });
                // Infinite, load more: scroll to product
            } else {
                // Get the selected product element
                var $selectedProduct = this.$element.find('[data-id="' + scrollData.productId + '"]').first();
                var scrollPos = $selectedProduct.offset().top - scrollData.offset;
                window.scrollTo({
                    top: scrollPos,
                    // behavior: 'smooth'
                    left: 0
                });
                if (window.IntersectionObserver) {
                    var intersectionObserver = new IntersectionObserver(function(entries, observer) {
                        for (var entry of entries) {
                            if (entry.isIntersecting) {
                                self.parent._changeProductListGobackPreviousPositionStatus(false);
                                observer.disconnect();
                            }
                        }
                    });
                    intersectionObserver.observe($selectedProduct[0]);
                } else {
                    setTimeout(() => {
                        self.parent._changeProductListGobackPreviousPositionStatus(false);
                    }, 500);
                }
            }
        }
    }
})();